/* ============================================
   LONGEVITY+ — Main JavaScript
   ============================================ */

// ---- CART DRAWER ----
(function() {
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-drawer-overlay');
  var closeBtn = document.getElementById('cart-drawer-close');
  var body = document.getElementById('cart-drawer-body');
  var footer = document.getElementById('cart-drawer-footer');

  function formatMoney(cents) {
    return 'S/ ' + (cents / 100).toFixed(2);
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function renderCart(cart) {
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="cart-empty">Tu carrito está vacío.</div>';
      footer.innerHTML = '';
      return;
    }
    body.innerHTML = cart.items.map(function(item) {
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<p class="cart-item__variant">' + item.variant_title + '</p>' : '';
      var opts = [1,2,3,4,5,6,7,8,9,10].map(function(n) {
        return '<option value="' + n + '"' + (n === item.quantity ? ' selected' : '') + '>' + n + '</option>';
      }).join('');
      return '<div class="cart-item">' +
        '<img class="cart-item__img" src="' + (item.image || '') + '" alt="' + item.product_title + '">' +
        '<div class="cart-item__details">' +
          '<p class="cart-item__name">' + item.product_title + '</p>' +
          variant +
          '<div class="cart-item__qty">' +
            '<span class="cart-item__qty-label">Cantidad:</span>' +
            '<select class="cart-item__qty-select" data-key="' + item.key + '">' + opts + '</select>' +
            '<button class="cart-item__remove" data-key="' + item.key + '" aria-label="Eliminar">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/></svg>' +
            '</button>' +
          '</div>' +
        '</div>' +
        '<span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
      '</div>';
    }).join('');

    footer.innerHTML =
      '<div class="cart-subtotal">' +
        '<span class="cart-subtotal__label">Subtotal</span>' +
        '<span class="cart-subtotal__amount">' + formatMoney(cart.total_price) + '</span>' +
      '</div>' +
      '<a href="/checkout" class="cart-checkout-btn">Continuar al pago &rarr;</a>';

    body.querySelectorAll('.cart-item__qty-select').forEach(function(sel) {
      sel.addEventListener('change', function(e) {
        var key = e.target.dataset.key;
        var qty = parseInt(e.target.value);
        body.innerHTML = '<div class="cart-drawer-loading"><div class="cart-drawer-spinner"></div></div>';
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
          body: JSON.stringify({id: key, quantity: qty})
        })
        .then(function() { return fetch('/cart.js').then(function(r) { return r.json(); }); })
        .then(renderCart)
        .catch(function(err) { console.error('Cart update error:', err); });
      });
    });

    body.querySelectorAll('.cart-item__remove').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        var key = e.currentTarget.dataset.key;
        body.innerHTML = '<div class="cart-drawer-loading"><div class="cart-drawer-spinner"></div></div>';
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
          body: JSON.stringify({id: key, quantity: 0})
        })
        .then(function() { return fetch('/cart.js').then(function(r) { return r.json(); }); })
        .then(renderCart)
        .catch(function(err) { console.error('Cart remove error:', err); });
      });
    });
  }

  function showLoading() {
    body.innerHTML = '<div class="cart-drawer-loading"><div class="cart-drawer-spinner"></div></div>';
    footer.innerHTML = '';
  }

  function addToCartAndOpen(variantId, quantity) {
    showLoading();
    openDrawer();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
      body: JSON.stringify({id: variantId, quantity: quantity || 1})
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return fetch('/cart.js').then(function(r) { return r.json(); });
    })
    .then(renderCart)
    .catch(function(err) {
      body.innerHTML = '<div class="cart-empty">Error al agregar. Intenta de nuevo.</div>';
      console.error(err);
    });
  }

  // Intercept all /cart/add form submissions
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form.getAttribute('action') === '/cart/add') {
      e.preventDefault();
      var fd = new FormData(form);
      addToCartAndOpen(fd.get('id'), parseInt(fd.get('quantity')) || 1);
    }
  });

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeDrawer(); });
})();

// ---- Mobile Nav Drawer ----
(function() {
  var toggle = document.getElementById('nav-toggle');
  var drawer = document.getElementById('mobile-nav');
  var overlay = document.getElementById('mobile-nav-overlay');
  var closeBtn = document.getElementById('mobile-nav-close');
  if (!toggle || !drawer || !overlay) return;

  function open() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    toggle.classList.add('is-active');
    toggle.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    toggle.classList.remove('is-active');
    toggle.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', function() {
    if (drawer.classList.contains('is-open')) close(); else open();
  });
  if (closeBtn) closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);
  drawer.querySelectorAll('a').forEach(function(a) { a.addEventListener('click', close); });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });
})();

// ---- Cart Counter ----
let cartCount = 0;
const cartCountEl = document.querySelector('.cart-count');

document.querySelectorAll('.btn-add-cart').forEach(btn => {
  btn.addEventListener('click', () => {
    cartCount++;
    if (cartCountEl) cartCountEl.textContent = cartCount;

    // Brief animation feedback
    btn.textContent = '✓ Added!';
    btn.style.background = '#2f855a';
    setTimeout(() => {
      btn.textContent = 'Add to Cart';
      btn.style.background = '';
    }, 1500);
  });
});

// ---- Sticky Header Shadow ----
const header = document.querySelector('.header');
window.addEventListener('scroll', () => {
  if (window.scrollY > 10) {
    header.style.boxShadow = '0 4px 20px rgba(0,0,0,0.1)';
  } else {
    header.style.boxShadow = '0 1px 0 rgba(0,0,0,0.08)';
  }
});

// ---- Smooth Scroll for Anchor Links ----
document.querySelectorAll('a[href^="#"]:not([data-rv-tab])').forEach(anchor => {
  anchor.addEventListener('click', e => {
    const target = document.querySelector(anchor.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

// ---- Newsletter Form ----
const newsletterForm = document.querySelector('.newsletter-form');
if (newsletterForm) {
  newsletterForm.addEventListener('submit', e => {
    e.preventDefault();
    const input = newsletterForm.querySelector('input');
    const btn = newsletterForm.querySelector('button');
    if (input.value.trim()) {
      btn.textContent = '✓ Subscribed!';
      btn.style.background = '#2f855a';
      input.value = '';
      setTimeout(() => {
        btn.textContent = 'Subscribe';
        btn.style.background = '';
      }, 3000);
    }
  });
}

// ---- Intersection Observer for Fade-in Animations ----
const observerOptions = {
  threshold: 0.1,
  rootMargin: '0px 0px -40px 0px'
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      observer.unobserve(entry.target);
    }
  });
}, observerOptions);

// Add fade-in class to animatable elements
document.querySelectorAll(
  '.product-card, .testimonial-card, .blog-card, .stat-item, .benefit-item, .faq-item'
).forEach((el, i) => {
  el.style.opacity = '0';
  el.style.transform = 'translateY(20px)';
  el.style.transition = `opacity 0.5s ease ${i * 0.05}s, transform 0.5s ease ${i * 0.05}s`;
  observer.observe(el);
});

document.addEventListener('DOMContentLoaded', () => {
  // Trigger visible class via MutationObserver trick
  const style = document.createElement('style');
  style.textContent = '.visible { opacity: 1 !important; transform: translateY(0) !important; }';
  document.head.appendChild(style);
});

// ---- Reviews Page (Testimonios) ----
(function() {
  var nav = document.querySelector('[data-rv-nav]');
  if (!nav) return;

  var spacer = document.querySelector('[data-rv-nav-spacer]');
  var tabs = nav.querySelectorAll('[data-rv-tab]');
  var header = document.querySelector('.header');

  function getHeaderBottom() {
    if (!header) return 0;
    return Math.max(0, header.getBoundingClientRect().bottom);
  }

  function getSections() {
    var list = [];
    tabs.forEach(function(tab) {
      var sel = tab.getAttribute('data-target');
      if (!sel) return;
      var el = document.querySelector(sel);
      if (el) list.push({ tab: tab, el: el });
    });
    return list;
  }

  var sections = getSections();

  function onScroll() {
    var headerBottom = getHeaderBottom();
    var triggerTop = spacer && spacer.classList.contains('is-active')
      ? spacer.getBoundingClientRect().top
      : nav.getBoundingClientRect().top;

    if (triggerTop <= headerBottom) {
      if (!nav.classList.contains('is-fixed')) {
        if (spacer) {
          spacer.style.height = nav.offsetHeight + 'px';
          spacer.classList.add('is-active');
        }
        nav.classList.add('is-fixed');
      }
      nav.style.top = headerBottom + 'px';
    } else if (nav.classList.contains('is-fixed')) {
      nav.classList.remove('is-fixed');
      nav.style.top = '';
      if (spacer) {
        spacer.classList.remove('is-active');
        spacer.style.height = '';
      }
    }

    if (sections.length) {
      var navBottom = headerBottom + nav.offsetHeight + 16;
      var active = sections[0];
      for (var i = sections.length - 1; i >= 0; i--) {
        if (sections[i].el.getBoundingClientRect().top <= navBottom + 16) {
          active = sections[i];
          break;
        }
      }
      tabs.forEach(function(t) { t.classList.remove('is-active'); });
      if (active) active.tab.classList.add('is-active');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function(e) {
      e.preventDefault();
      tabs.forEach(function(t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      var target = document.querySelector(tab.getAttribute('data-target'));
      if (target) {
        var offset = getHeaderBottom() + nav.offsetHeight + 8;
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - offset,
          behavior: 'smooth'
        });
      }
    });
  });

  // Before/After category filters
  var baFilters = document.querySelector('[data-ba-filters]');
  var baSection = document.getElementById('rv-results');
  var baShowMore = document.querySelector('[data-ba-show-more]');
  if (baShowMore && baSection) {
    baShowMore.addEventListener('click', function() {
      baSection.classList.add('is-expanded');
      baShowMore.setAttribute('aria-expanded', 'true');
      baShowMore.classList.add('is-open');
    });
  }
  if (baFilters) {
    var baCards = document.querySelectorAll('#rv-results .ba-card');
    baFilters.querySelectorAll('[data-ba-filter]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var filter = btn.getAttribute('data-ba-filter');
        baFilters.querySelectorAll('[data-ba-filter]').forEach(function(b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        baCards.forEach(function(card) {
          var cats = (card.getAttribute('data-category') || '').split(' ');
          if (filter === 'all' || cats.indexOf(filter) !== -1) {
            card.classList.remove('ba-card--filtered');
          } else {
            card.classList.add('ba-card--filtered');
          }
        });
      });
    });
  }

  // Written reviews are handled by luciera-reviews.js (data-driven widget)
})();

// ---- LIVE VIEWERS (social proof) ----
(function () {
  var nodes = document.querySelectorAll('.luc-lv__count');
  if (!nodes.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function rand(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  nodes.forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10) || 22;
    var max = parseInt(el.getAttribute('data-max'), 10) || 58;
    var interval = parseInt(el.getAttribute('data-interval'), 10) || 5500;
    if (min > max) { var tmp = min; min = max; max = tmp; }

    el.textContent = String(rand(min, max));
    if (reduce) return;

    setInterval(function () {
      var current = parseInt(el.textContent, 10) || min;
      var next = current + Math.floor(Math.random() * 7) - 3;
      next = Math.max(min, Math.min(max, next));
      el.style.opacity = '0.45';
      setTimeout(function () {
        el.textContent = String(next);
        el.style.opacity = '1';
      }, 140);
    }, interval);
  });
})();

// ---- STICKY “Realizar pedido ahora” (gold) ----
(function () {
  var wrap = document.getElementById('luc-sticky-cta-wrap');
  var btn = document.getElementById('luc-sticky-cta');
  if (!wrap || !btn) return;

  function findPrimaryCta() {
    return (
      document.getElementById('amp-checkout-btn') ||
      document.getElementById('lrr-checkout-btn') ||
      document.querySelector('.luc-primary-atc') ||
      document.querySelector('.amp-cod-btn') ||
      document.querySelector('.lrr-cod-btn') ||
      document.querySelector('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] button[name="add"]')
    );
  }

  var target = findPrimaryCta();
  if (!target) return;

  document.body.classList.add('has-luc-sticky-cta');
  // Start hidden — first IO callback decides visibility (avoids flash over buy box)
  wrap.hidden = true;
  document.body.classList.remove('luc-sticky-cta-visible');

  var desktopMq = window.matchMedia('(min-width: 769px)');
  var buyBox = document.querySelector('.amp-info, .lrr-info, .amp-bundles');

  function setVisible(show) {
    wrap.hidden = !show;
    document.body.classList.toggle('luc-sticky-cta-visible', !!show);
  }

  function rebindObserver() {
    if (stickyIo) stickyIo.disconnect();

    // Desktop: hide sticky while the whole buy-box column is on screen
    // (prevents gold sticky overlapping pack selectors / main ATC).
    // Mobile: hide only when the primary ATC button itself is on screen.
    var observeEl = desktopMq.matches && buyBox ? buyBox : target;
    var opts = desktopMq.matches
      ? { root: null, threshold: 0, rootMargin: '0px 0px -12% 0px' }
      : { root: null, threshold: 0.2, rootMargin: '0px 0px -6% 0px' };

    stickyIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setVisible(!entry.isIntersecting);
      });
    }, opts);
    stickyIo.observe(observeEl);

    // Immediate sync in case observe fires late
    var rect = observeEl.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var inView = rect.top < vh * 0.94 && rect.bottom > vh * 0.06;
    setVisible(!inView);
  }

  var stickyIo = null;
  if ('IntersectionObserver' in window) {
    rebindObserver();
    if (typeof desktopMq.addEventListener === 'function') {
      desktopMq.addEventListener('change', rebindObserver);
    } else if (typeof desktopMq.addListener === 'function') {
      desktopMq.addListener(rebindObserver);
    }
  } else {
    setVisible(true);
  }

  btn.addEventListener('click', function () {
    try {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (e) {
      target.scrollIntoView(true);
    }
    setTimeout(function () {
      if (typeof target.focus === 'function') {
        try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
      }
      if (typeof target.click === 'function') {
        target.click();
      }
    }, 350);
  });
})();



/* ── Horizontal snap carousels (testimonials / mini-reviews / stories) ── */
(function () {
  function initTrack(track, root) {
    if (!track || track.dataset.lucCarouselReady === '1') return;
    track.dataset.lucCarouselReady = '1';
    root = root || track.closest('[data-luc-carousel]') || track.parentElement;

    var prev = root && root.querySelector('[data-luc-carousel-prev]');
    var next = root && root.querySelector('[data-luc-carousel-next]');

    function slideAmount() {
      var card = track.children[0];
      if (!card) return Math.max(240, track.clientWidth * 0.82);
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '14') || 14;
      return card.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    function scrollByDir(dir) {
      track.scrollBy({ left: dir * slideAmount(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
    if (next) next.addEventListener('click', function () { scrollByDir(1); });
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateArrows);
    }, { passive: true });

    var down = false, startX = 0, startLeft = 0;
    track.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      down = true;
      startX = e.pageX;
      startLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    window.addEventListener('mouseup', function () {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
      updateArrows();
    });
    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      e.preventDefault();
      track.scrollLeft = startLeft - (e.pageX - startX);
    });

    updateArrows();
    window.addEventListener('resize', updateArrows);
  }

  function boot() {
    document.querySelectorAll('[data-luc-carousel-track]').forEach(function (track) {
      initTrack(track);
    });
    document.querySelectorAll('.acne-stories__grid, .combo-stories__grid').forEach(function (track) {
      initTrack(track, track.parentElement);
    });
    document.querySelectorAll('.amp-mini-reviews__track').forEach(function (track) {
      initTrack(track, track.closest('.amp-mini-reviews'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
